/**
 * Layout: Theme
 * -----------------------------------------------------------------------------
 * Entry file for all global theme scripts.
 *
 */
import "@/layout/theme.scss";

/**
 * Global Basis functions.
 */
window.basis = window.basis || {};

/**
 * Import functions
 */

const template = document.querySelector("body").dataset.template;
const pagePath = window.location.pathname;
const pageHasMainProduct = document.querySelector(".pdp-page");
const pageHasFeaturedProduct = document.querySelector(".featured-product");

require("~/core/global");
require("~/core/theme-editor");

if (template === "index") require("~/components/loader");
require("~/components/media-loader");
require("~/components/newsletter-popup");
require("~/components/live-chat");
if (
  pagePath != "/pages/world-of-reza" &&
  pagePath != "/pages/about" &&
  pagePath != "/pages/new-york-studio" &&
  pagePath != "/pages/legacy" &&
  pagePath != "/pages/gem-guide" &&
  pagePath != "/pages/sustainability" &&
  pagePath != "/blogs/world-of-reza" &&
  !document.body.classList.contains("archive") &&
  !pagePath.startsWith("/blogs/world-of-reza/")
) {
  require("~/components/bell");
}
require("~/components/audio-player");
require("~/components/cart");
require("~/components/cart-drawer");
require("~/components/cart-notification");
require("~/components/cookie-message");
require("~/components/details-disclosure");
require("~/components/details-modal");
require("~/components/dynamic-rollover");
require("~/components/facets");
require("~/components/media-gallery");
require("~/components/navigation");
require("~/components/password-modal");
require("~/components/pickup-availability");
require("~/components/predictive-search");
require("~/components/product-form");
if (pageHasMainProduct || pageHasFeaturedProduct)
  require("~/components/product-modal");
require("~/components/product-model");
require("~/components/quick-add");
require("~/components/share");
require("~/components/show-more");
require("~/components/drawer");
if (pageHasMainProduct) require("~/components/pdp-slider");
require("~/components/image-slider");
require("~/components/video-player");
require("~/components/wor-landing");
require("~/components/concierge-drawer");
require("~/components/accordion");
require("~/components/purchase-description");
require("~/components/product-variations-slider");
require("~/components/alt-nav");
if (document.querySelector(".swiper-menu")) require("~/components/swiper-tabs");
if (document.querySelector(".tab-options")) require("~/components/tabs");
if (template === "product") require("~/components/pdp-account-modal");
if (pagePath === "/pages/gem-guide") require("~/components/overlay-gem-guide");
if (document.querySelector(".global-back-to-top"))
  require("~/components/global-back-to-top");
if (template === "product" || template === "collection")
  require("~/components/pdp-navigation");
require("~/components/audio-popup");
require("~/components/text-detail-popup");
require("~/components/custom-select");
if (
  template === "product" ||
  template === "collection" ||
  pagePath === "/pages/size-guide"
)
  require("~/components/size-chart");
if (template === "product" || template === "collection")
  require("~/components/product-tabs");
require("~/components/address");
if (template === "product" || template === "collection")
  require("~/components/product-recommendations");
require("~/components/grid-slider");
require("~/components/image-slide-with-text-slider");
require("~/components/hero-banner");
require("~/components/footer");
require("~/components/select-size");
if (pagePath === "/pages/legacy") require("~/components/legacy");
require("~/templates/account-forms");
require("~/templates/customer-account");
require("~/templates/customer");
require("~/templates/wishlist");
if (pagePath === "/pages/gem-guide") require("~/templates/gem-guide");
if (pagePath === "/pages/bespoke") require("~/templates/bespoke");
if (pagePath === "/pages/careers") require("~/templates/careers");
if (pagePath === "/pages/about") require("~/templates/about");
if (pagePath === "/pages/new-york-studio") require("~/templates/studio");
if (pagePath === "/pages/sustainability") require("~/templates/sustainability");
if (
  pagePath === "/pages/wishlist" ||
  pagePath === "/pages/share-wishlist" ||
  pagePath === "/pages/swym-share-wishlist"
)
  require("~/components/share-confirmation-message");
